var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRiseWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.6333 2.45508c-7.53005 0-13.6333 6.16695-13.6333 13.77252 0 7.6055 6.10325 13.7724 13.6333 13.7724 7.53 0 13.6332-6.1669 13.6332-13.7724 0-7.60557-6.1032-13.77252-13.6332-13.77252zm7.7315 13.09212c-.065.3757-.4206.6804-.7925.6804h-6.939l-.8115 4.6532c-.0649.3757-.4206.6803-.7925.6803h-6.26549c-.37191 0-.62074-.3046-.55448-.6803l.69377-3.9729c.06491-.3757.42059-.6803.79249-.6803h6.93901l.8114-4.6533c.0649-.3757.4206-.6803.7925-.6803h6.2656c.3719 0 .6207.3046.5544.6803z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiseWallet);
export default __webpack_public_path__ + "static/media/riseWallet.6462bb9afef84b760441f79cf2924862.svg";
export { ForwardRef as ReactComponent };